import React, { useRef, useLayoutEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import movies from './movies'
const Index = () => {
  const[activeCls, setActiveCls] = useState("active1")
  const columns = [
    {
      id: 1,
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
      reorder: true
    },
    {
      id: 2,
      name: "Director",
      selector: (row) => row.director,
      sortable: true,
      reorder: true
    },
    {
      id: 3,
      name: "Runtime (m)",
      selector: (row) => row.runtime,
      sortable: true,
      right: true,
      reorder: true
    }
  ];
  return (
    <>
      <section>
        <div className="container-fluid">
          <div className="row  Average-chart ">
            <div className="col-md-12">
              <div className="tabbutton">
                <button className={activeCls === "active1" ? "active" : ""} onClick={() => {setActiveCls("active1")}}>SPENDS</button>&nbsp;&nbsp;
                <button className={activeCls === "active2" ? "active" : ""} onClick={() => {setActiveCls("active2")}}>EARNINGS</button>
              </div>
              <div className="" style={{borderRadius: "22px", background: "#1d202a"}}>
                <div className="chart">
                  <div className="">
                    <DataTable
                      title="Manage Swaps"
                      columns={columns}
                      data={movies}
                      paginationPerPage={5}

                      defaultSortFieldId={1}
                      // sortIcon={<SortIcon />}
                      pagination
                      selectableRows
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid">
          <div className="row Average-chart mb-5">

            <div className="col-md-12">

            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Index;
